/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hours_SundayInputs */

const en_contact_hours_sunday = /** @type {(inputs: Contact_Hours_SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday`)
};

const pl_contact_hours_sunday = /** @type {(inputs: Contact_Hours_SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedziela`)
};

/**
* | output |
* | --- |
* | "Sunday" |
*
* @param {Contact_Hours_SundayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hours_sunday = /** @type {((inputs?: Contact_Hours_SundayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hours_SundayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_hours_sunday(inputs)
	return en_contact_hours_sunday(inputs)
});